import React from 'react';

import {isReactNativeWeb, isOpfsSupported, getIsTauriWebview} from '@/utils/user_agent';
import {useModule} from '@/store/kysely_module';

const isMobileBrowser = !isReactNativeWeb() && !isOpfsSupported() && !getIsTauriWebview();

export const OfflineBetaMessage = () => {
    const isOfflineMode = useModule('User').isOfflineMode.useState();
    if (!isOfflineMode || !isMobileBrowser) {
        return null;
    }

    return (
        <div>
            {isMobileBrowser && (
                <p>
                    Since you are using a mobile device in browser offline mode, you may experience issues working with larger files ({'>'} 10 MB).
                </p>
            )}
        </div>
    );
};
